export const filterNameAdapter = (basicForm: string) => {
  return {
    1: [
      {
        identifier: 'BRAND__STRING',
        type: 'collapsibleFilter',
        displayOrder: 1,
        translationId: 'filters.valve.displayName.BRAND__STRING',
        displayName: 'Brand',
      },
      {
        identifier: 'EGTF_1111__STRING',
        type: 'collapsibleFilter',
        displayOrder: 2,
        translationId: 'filters.valve.displayName.EGTF_1111__STRING',
        displayName: 'Type',
      },
      {
        identifier: 'EF022461__STRING',
        type: 'collapsibleFilter',
        displayOrder: 3,
        translationId: 'filters.valve.displayName.EF022461__STRING',
        displayName: 'Body Material',
      },
      {
        identifier: 'EF022666__STRING',
        type: 'radioGroup',
        displayOrder: 4,
        translationId: 'filters.valve.displayName.EF022666__STRING',
        displayName: 'Norm',
      },
      {
        identifier: 'EF023191__STRING',
        type: 'collapsibleFilter',
        displayOrder: 5,
        translationId: 'filters.valve.displayName.EF023191__STRING',
        displayName: 'Nominal inner diameter',
      },
      {
        identifier: 'EF020007__STRING',
        type: 'collapsibleFilter',
        displayOrder: 6,
        translationId: 'filters.valve.displayName.EF020007__STRING',
        displayName: 'Pressure class',
      },
      {
        identifier: 'EF000443__STRING',
        type: 'collapsibleFilter',
        displayOrder: 7,
        translationId: 'filters.valve.displayName.EF000443__STRING',
        displayName: 'Connection type',
      },
      {
        identifier: 'EF024700__STRING',
        type: 'collapsibleFilter',
        displayOrder: 8,
        translationId: 'filters.valve.displayName.EF024700__STRING',
        displayName: 'Seat material',
      },
      {
        identifier: 'EF024700_EGTF_3605__STRING',
        type: 'collapsibleFilter',
        displayOrder: 9,
        translationId: 'filters.valve.displayName.EF024700_EGTF_3605__STRING',
        displayName: 'Seat material',
      },
      {
        identifier: 'EF023840__STRING',
        type: 'collapsibleFilter',
        displayOrder: 10,
        translationId: 'filters.valve.displayName.EF023840__STRING',
        displayName: 'Disc material',
      },
    ],
    2: [
      ...(basicForm === 'electric_actuator'
        ? [
            {
              identifier: 'EF020233__STRING',
              type: 'collapsibleFilter',
              displayOrder: 4,
              translationId: 'filters.actuator.displayName.EF020233__STRING',
              displayName: 'Supply Voltage',
            },
            {
              identifier: 'EF021858__STRING',
              type: 'collapsibleFilter',
              displayOrder: 5,
              translationId: 'filters.actuator.displayName.EF021858__STRING',
              displayName: 'IP',
            },
            {
              identifier: 'EF004663__STRING',
              type: 'collapsibleFilter',
              displayOrder: 6,
              translationId: 'filters.actuator.displayName.EF004663__STRING',
              displayName: 'Atex',
            },
            {
              identifier: 'EF000462__STRING',
              type: 'collapsibleFilter',
              displayOrder: 7,
              translationId: 'filters.actuator.displayName.EF000462__STRING',
              displayName: 'Actuator function',
            },
          ]
        : []),
      ...(basicForm === 'pneumatic_actuator'
        ? [
            {
              identifier: 'BRAND__STRING',
              type: 'collapsibleFilter',
              displayOrder: 1,
              translationId: 'filters.actuator.displayName.BRAND__STRING',
              displayName: 'Brand',
            },
          ]
        : []),
      ...(basicForm === 'gearbox'
        ? [
            {
              identifier: 'EF005474__STRING',
              type: 'collapsibleFilter',
              displayOrder: 1,
              translationId: 'filters.actuator.displayName.EF005474__STRING',
              displayName: 'IP class',
            },
            {
              identifier: 'EF022461__STRING',
              type: 'collapsibleFilter',
              displayOrder: 2,
              translationId: 'filters.actuator.displayName.EF022461__STRING',
              displayName: 'Material housing',
            },
          ]
        : []),
    ],
    3: [
      {
        identifier: 'BRAND__STRING',
        type: 'collapsibleFilter',
        displayOrder: 1,
        translationId: 'filters.monitoring.displayName.BRAND__STRING',
        displayName: 'Brand',
      },
      {
        identifier: 'EF002656__STRING',
        type: 'collapsibleFilter',
        displayOrder: 2,
        translationId: 'filters.monitoring.displayName.EF002656__STRING',
        displayName: 'Type of switch',
      },
      {
        identifier: 'EGTF_5786__STRING',
        type: 'collapsibleFilter',
        displayOrder: 3,
        translationId: 'filters.monitoring.displayName.EGTF_5786__STRING',
        displayName: 'Switch model',
      },
      {
        identifier: 'EF000854__STRING',
        type: 'radioGroup',
        displayOrder: 4,
        translationId: 'filters.monitoring.displayName.EF000854__STRING',
        displayName: 'ATEX class',
      },
      {
        identifier: 'EF021858__STRING',
        type: 'collapsibleFilter',
        displayOrder: 5,
        translationId: 'filters.monitoring.displayName.EF021858__STRING',
        displayName: 'IP class',
      },
    ],
    4: [
      {
        identifier: 'BRAND__STRING',
        type: 'collapsibleFilter',
        displayOrder: 1,
        translationId: 'filters.solenoid.displayName.BRAND__STRING',
        displayName: 'Brand',
      },
      {
        identifier: 'EF000104__STRING',
        type: 'collapsibleFilter',
        displayOrder: 2,
        translationId: 'filters.solenoid.displayName.EF000104__STRING',
        displayName: 'Voltage',
      },
      {
        identifier: 'EF004663__STRING',
        type: 'radioGroup',
        displayOrder: 3,
        translationId: 'filters.solenoid.displayName.EF004663__STRING',
        displayName: 'ATEX class',
      },
    ],
  };
};
